import { QUERY_KEY } from '@constants/queries';

import { useQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import { Category } from '@utils/typesPages/types';
import { CACHE_TIME_TANSTACK } from '@constants/configurations';

export const fetchCategoryBySlug = async (slug: string) => {
  const { data: response } = await GET<Category>(`/api/categories/${slug}`);

  return response;
};

export const useFetchCategoryBySlug = (slug: string) => {
  return useQuery({
    queryKey: [QUERY_KEY.FETCH_CATEGORY_BY_SLUG, slug],
    queryFn: () => fetchCategoryBySlug(slug),
    enabled: !!slug,
    refetchInterval: CACHE_TIME_TANSTACK,
    gcTime: CACHE_TIME_TANSTACK,
  });
};
